import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "rsuite/Dropdown/styles/index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Config from "src/components/common/Config";
import { Box, Divider, IconButton, List, ListItem, ListItemAvatar, ListItemText, SvgIcon, Typography, useMediaQuery, useTheme } from "@mui/material";
import { AiOutlineMenu } from "react-icons/ai";
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import { HiOutlineLogout } from "react-icons/hi";


const NAVIGATION_ITEMS = [
  {
    title: "Dashboard",
    path: "/dashboard",
    roles: [8, 18],
    children: [],
  },
  {
    title: "Sales",
    roles: [8],
    children: [
      { title: "New Sales", path: "/sales/newsales" },
      { title: "Order History", path: "/sales/shistory" },
      { title: "Reject Sales History", path: "/sales/reject_sales" },
      { title: "Epos", path: "/sales/Epos" },
      { title: "Sales Report (Epos)", path: "/sales/epos_sales" },
      { title: "Quick Order", path: "/sales/Quick_Order" },
    ],
  },
  {
    title: "Picking",
    roles: [8],
    children: [
      { title: "Create Picking", path: "/picking/picking_create" },
      { title: "Picking List", path: "/picking/picking_list" },
      { title: "Picking History", path: "/picking/picking_history" },
      { title: "Short QTY", path: "/picking/short_qty" },
      { title: "Proforma Invoice", path: "/picking/proforma" },
    ],
  },
  {
    title: "Dispatch & Deliveries",
    roles: [8],
    children: [
      { title: "Create Manifest", path: "/delivery/route_planing" },
      { title: "Manifest List", path: "/manifest_list" },
      { title: "Open Trip", path: "/open_trips" },
      { title: "Complete Trip", path: "/complete_trips" },
    ],
  },
  {
    title: "Master",
    roles: [8],
    children: [
      { title: "Products", path: "/products" },
      { title: "Product Price Variation", path: "/products_price_variation" },
      { title: "Suppliers", path: "/supplier" },
      { title: "Users", path: "/users" },
      { title: "Product Categories", path: "/product_category" },
      { title: "Brands", path: "/Brands" },
      { title: "Units", path: "/Units" },
      { title: "Customers", path: "/customers" },
      { title: "Contra Price Customers", path: "/ContraList" },
    ],
  },
  {
    title: "Reports",
    roles: [8],
    children: [
      { title: "Customer Not Order", path: "/reports/customer_not_order_report" },
      { title: "Inventory Sales Report", path: "/reports/inventory_sales_report" },
      { title: "MIS Report", path: "/reports/mis_report" },
      { title: "Cross Off Report", path: "/reports/missing_order" },
      { title: "Sales Rep Report", path: "/reports/sales_report" },
      { title: "Profit and Loss", path: "/reports/profit_loss_report" },
      { title: "Order Location Report", path: "/reports/lat_long_report" },
      { title: "Cashier Report", path: "/reports/Cashier_report" },
    ],
  },
  {
    title: "Purchases",
    roles: [8],
    children: [
      { title: "Purchases Order", path: "/purchases/purchases_order" },
      { title: "Purchases History", path: "/purchases/purchases_grn" },
    ],
  },
  {
    title: "Account",
    roles: [8],
    children: [
      { title: "Push to Sage", path: "/account/push_sage" },
      { title: "All Push Invoice", path: "/account/push_invoice" },
      { title: "Received Payments", path: "/account/payments" },
      { title: "Customer Accounts", path: "/account/customer_accounts" },
      { title: "Supplier Ledger", path: "/account/supplier_ledger" },
      { title: "Payment Ledger", path: "/account/payment_ladger" },
      { title: "My Ledger", path: "/account/my_ledger" },
      { title: "Product Ledger", path: "/account/product_ledger" },
      { title: "Stock Take", path: "/stock_take/history" },
    ],
  },
  {
    title: "Return",
    roles: [8],
    children: [
      { title: "Return List", path: "/return_list" },
    ],
  },
  {
    title: "Promotion",
    roles: [8],
    children: [
      { title: "Promotions", path: "/Promotions/Promos" },
    ],
  },
  {
    title: "Incomplete Orders",
    roles: [18],
    children: [
      { title: "Incomplete Order List", path: "/sales/IncompleteOrderList" },
      { title: "Inventory Report", path: "/sales/InventoryReport" },
    ],
  },
];
const Styles = {
  signOutBox: {
    fontSize: "18px",
    transition: "0.3s",
    color: " #000",
    borderBottom: " none",
    padding: "10px",
    cursor: "pointer"
  }
}
export default function TopBar({ onMobileNavOpen }) {
  const [dropdownState, setDropdownState] = useState({});
  const [profileDropdown, setProfileDropdown] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [showNotifications, setShowNotifications] = useState(false);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const [notificationCount, setNotificationCount] = useState(4);
  const [notificationData, setNotificationData] = useState([]);
  const accessToken = localStorage.getItem("accessToken");
  const userId = localStorage.getItem("userId");
  const userRole = parseInt(localStorage.getItem("user_role"), 10);
  const siteName = localStorage.getItem("site_name");
  const firstName = localStorage.getItem("first_name");
  const lastName = localStorage.getItem("last_name");
  const theme = useTheme();
  const islgUp = useMediaQuery(theme.breakpoints.up(1278));

  useEffect(() => {
    if (!accessToken) navigate("/react/login");
  }, [accessToken, navigate]);

  const toggleDropdown = (key) => {
    setDropdownState((prevState) => ({ ...prevState, [key]: !prevState[key] }));
  };

  const handleLogout = () => {
    [
      "site_name",
      "first_name",
      "last_name",
      "accessToken",
      "userId",
      "user_role",
    ].forEach((key) => localStorage.removeItem(key));
    localStorage.clear();
    navigate("/");

  };

  const renderDropdown = (items, key) => (
    <li
      className={`dropdown  nav-item with-divider ${dropdownState[key] ? "open" : ""}`}
      key={key}
      onMouseEnter={() => setDropdownState({ ...dropdownState, [key]: true })}
      onMouseLeave={() => setDropdownState({ ...dropdownState, [key]: false })}
    >
      <a href="#">
        {key} <i className="bi bi-chevron-down dropdown-indicator"></i>
      </a>
      <ul>
        {items.map((item) => (
          <li key={item.path} >
            <Link to={item.path} className={location.pathname === item.path ? "active sub-nav-item" : "sub-nav-item"}>
              {item.title}
            </Link>
          </li>
        ))}
      </ul>
    </li>
  );

  // Toggle the notifications dropdown
  const toggleNotifications = (e) => {
    e.stopPropagation(); // Prevent event bubbling
    setShowNotifications(!showNotifications);
    setShowProfileDropdown(false);
  };

  const getNotificationData = async () => {
    const apiBCUrl = `${Config.API_URL}/ws-get-notification-data`;
    try {
      const response = await fetch(apiBCUrl, {
        method: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch notification list");
      }

      const data = await response.json();
      // console.log(data);
      setNotificationData(data.data);
    } catch (error) {
      console.log("Error fetch notification data", error);
    }
  };


  useEffect(() => {
    getNotificationData();
    // Close notification dropdown and profile dropdown when clicked outside
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [showNotifications, showProfileDropdown]);
  const handleClickOutside = (e) => {
    if (showNotifications && !e.target.closest(".notification-drop")) {
      setShowNotifications(false);
    }
    if (showProfileDropdown && !e.target.closest(".nav-profile")) {
      setShowProfileDropdown(false);
    }
  };

  return (
    <header className="header fixed-top">
      <div className="container-fluid d-flex align-items-center justify-content-between" style={{ padding: "10px 0" }}>
        <Link to={`/dashboard/${accessToken}/${userId}`} className="logo-area">
          {siteName || "Site Name"}
        </Link>

        <nav id="navbar" className="navbar">
          <ul>
            {NAVIGATION_ITEMS.filter((item) => item.roles.includes(userRole)).map((item, index, arr) => (
              item.children.length > 0
                ? renderDropdown(item.children, item.title)
                : (
                  <li key={item.path} className={"nav-item with-divider"}>
                    <Link
                      to={`${item.path}/${accessToken}/${userId}`}
                      className={location.pathname === `${item.path}/${accessToken}/${userId}` ? "active" : ""}
                    >
                      {item.title}
                    </Link>
                  </li>
                )
            ))}
          </ul>
        </nav>

        <div className="header-nav">
          <ul className="d-flex align-items-center">
            <li className="nav-item dropdown">
              <a
                className={`nav-link nav-icon ${showNotifications ? "active" : ""
                  }`}
                onClick={toggleNotifications}
              >
                <i class="bi bi-bell"></i>
                <span class="badge bg-primary badge-number">{notificationData && notificationData.length}</span>
              </a>
              <ul class="notification-drop notie">
                {showNotifications && (
                  <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper', borderRadius: "15px",
                    maxHeight: "290px", overflow: "auto"
                   }}>
                    {notificationData && notificationData.map((item, index) => {
                      if (item.status === "expirePromo") {
                        const formattedDate = new Date(
                          item.expDate
                        ).toLocaleDateString("en-GB");
                        return (
                          <div>
                            <Box sx={{ display: "flex", gap: "10px", alignItems: "start", padding: "5px" }}>
                              <NotificationsActiveIcon sx={{fontSize:"22px"}} />
                              <Box sx={{ display: "grid", gap: "3px" }}>
                                <Typography variant="h4" fontSize={"12px"}>Promotion expired</Typography>
                                {/* <Box sx={{ width: "100%", height: "1px", background: "rgb(0, 0, 0, 0.25)" }} /> */}
                                <Typography  fontSize={"14px"} fontWeight={"600"}>{item.productName}</Typography>
                                <Typography fontSize={"12px"}>{formattedDate}</Typography>
                              </Box>
                            </Box>
                            <Box sx={{ width: "100%", height: "1px", background: "rgb(0, 0, 0, 0.25)" }} />
                          </div>
                        )
                      } else {
                        return (
                          <div>
                            <Box sx={{ display: "flex", gap: "10px", alignItems: "start", padding: "5px" }}>
                              <NotificationsActiveIcon sx={{fontSize:"22px" }}/>
                              <Box sx={{ display: "grid", gap: "3px" }}>
                                <Typography fontSize={"12px"}>Product is below minimum quantity</Typography>
                                {/* <Box sx={{ width: "100%", height: "1px", background: "rgb(0, 0, 0, 0.25)" }} /> */}
                                <Typography  fontSize={"14px"} fontWeight={"600"}>{item.productName}</Typography>
                                <Typography fontSize={"12px"}> Current Stock : {parseInt(item.qty)}</Typography>
                              </Box>
                            </Box>
                            <Box sx={{ width: "100%", height: "1px", background: "rgb(0, 0, 0, 0.25)" }} />
                          </div>
                        )}
                    })}
                  </List>)}</ul>
            </li>
            <li className="nav-item dropdown">
              <a
                className="nav-link nav-profile"
                onClick={() => setProfileDropdown(!profileDropdown)}
              >
                {firstName} {lastName}
              </a>
              <ul
                className={`dropdown-menu dropdown-menu-end dropdown-menu-arrow profile ${profileDropdown ? "active" : ""
                  }`}
              >
                {profileDropdown && (
                  <li>
                    <Box sx={Styles.signOutBox} onClick={handleLogout}>
                      <HiOutlineLogout style={{ fontSize: "24px" }} /> &nbsp;Sign Out
                    </Box>
                  </li>
                )}
              </ul>
            </li>
            <li>
              {!islgUp &&
                <IconButton
                  color="#fff"
                  onClick={onMobileNavOpen}
                  style={{ margin: "0 10px" }}
                >
                  <SvgIcon fontSize="small">
                    <AiOutlineMenu style={{ color: "#fff" }} />
                  </SvgIcon>
                </IconButton>
              }
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
};
